import React from 'react';

import Typography from './Typography';
import {
  CardContainer,
  IconWrapper,
  ContentWrapper,
  CheckWrapper,
} from '../../asset/styled/component/OptionCardStyled';

import previousCheckPrimary from '../../asset/img/previous_check_primary.svg';
import previousCheckDefault from '../../asset/img/previous_check_default.svg';

/**
 * 선택 가능한 옵션 카드 컴포넌트
 * @param {boolean} isActive - 활성화 여부
 * @param {function} onClick - 클릭 핸들러
 * @param {string} icon - 아이콘 이미지 경로
 * @param {string} iconAlt - 아이콘 alt 텍스트
 * @param {string} title - 카드 제목
 * @param {string} description - 카드 설명
 * @param {boolean} showCheck - 체크 아이콘 표시 여부 (기본: true)
 */
const OptionCard = ({
  isActive = false,
  onClick,
  icon,
  iconAlt = '',
  title,
  description,
  showCheck = true,
}) => {
  return (
    <CardContainer $isActive={isActive} onClick={onClick}>
      {icon && (
        <IconWrapper>
          <img src={icon} alt={iconAlt} />
        </IconWrapper>
      )}
      <ContentWrapper>
        <Typography variant="body1Medium">{title}</Typography>
        <Typography
          variant="body2Medium"
          style={{ color: isActive ? 'var(--GrayScale-700)' : 'var(--GrayScale-600)' }}>
          {description}
        </Typography>
      </ContentWrapper>
      {showCheck && (
        <CheckWrapper>
          <img src={isActive ? previousCheckPrimary : previousCheckDefault} alt="check" />
        </CheckWrapper>
      )}
    </CardContainer>
  );
};

export default OptionCard;
